import { css } from "styled-components";

export const cardStyle = css`
	margin: 10px 0 !important;
	border-radius: 10px;
	padding: 15px;
	border: 1px solid var(--border-color);
`;

export const FilterButtonSelected = "padding: 2px 10px; filter: brightness(0.5); margin: 3px 3px;";

export const FilterButton = "padding: 2px 10px; margin: 3px 3px;";
